export default __webpack_public_path__ + "static/media/submitOTP.f1b59d0f.png";